import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-eula',
  templateUrl: './eula.component.html',
  styleUrls: ['./eula.component.scss']
})
export class EulaComponent implements OnInit {
  name = this.route.snapshot.queryParamMap.get('name');
  textOnly = this.route.snapshot.queryParamMap.get('textOnly') === 'true';
  sectionTitle: string;

  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.sectionTitle = 'EULA Agreement';
    if (this.textOnly) {
      document.querySelector('app-header').remove();
      document.querySelector('.navigation').remove();
      document.querySelector('.footer').remove();
    }
  }

}
